// ============================================================================
// Hook per scheda dipendente completa — Supabase (dipendenti_scheda)
// ============================================================================

import { useState, useEffect, useCallback } from "react";
import { supabase, isSupabaseConfigured } from "../lib/supabase";

export function useSchedaDipendenti() {
  const [schedaDipendenti, setSchedaDipendenti] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!isSupabaseConfigured) { setLoading(false); return; }

    supabase
      .from("dipendenti_scheda")
      .select("*")
      .then(({ data, error }) => {
        if (error) { console.error("Errore caricamento schede:", error); setLoading(false); return; }
        if (data) {
          const map = {};
          data.forEach((r) => { map[r.id] = r; });
          setSchedaDipendenti(map);
        }
        setLoading(false);
      });

    const channel = supabase
      .channel("dipendenti_scheda_realtime")
      .on("postgres_changes", { event: "*", schema: "public", table: "dipendenti_scheda" }, (payload) => {
        if (payload.eventType === "DELETE") {
          setSchedaDipendenti((prev) => {
            const next = { ...prev };
            delete next[payload.old.id];
            return next;
          });
        } else {
          setSchedaDipendenti((prev) => ({ ...prev, [payload.new.id]: payload.new }));
        }
      })
      .subscribe();

    return () => supabase.removeChannel(channel);
  }, []);

  const saveSchedaDipendente = useCallback(async (id, data) => {
    const entry = { id, ...data };
    setSchedaDipendenti((prev) => ({ ...prev, [id]: { ...prev[id], ...entry } }));
    if (!isSupabaseConfigured) return { success: true };
    const { error } = await supabase
      .from("dipendenti_scheda")
      .upsert([entry], { onConflict: "id" });
    if (error) return { success: false, error: error.message };
    return { success: true };
  }, []);

  return { schedaDipendenti, loading, saveSchedaDipendente };
}
